module.exports = __webpack_public_path__ + "img/img-area-pld.47a34131.png";